import { useAppSelector } from "~src/redux";

export const useFeatureFlag = (flagName: string) => {
  return useAppSelector((state) => !!state.features[flagName]);
};
